import React from 'react'
import { fetchAnalysisEnabled } from '../services/analysisService'

export function useAnalysisEnabled() {
  const [enabled, setEnabled] = React.useState<boolean | null>(null)

  React.useEffect(() => {
    let mounted = true
    ;(async () => {
      try {
        const ok = await fetchAnalysisEnabled()
        if (!mounted) return
        setEnabled(ok)
      } catch {
        if (!mounted) return
        setEnabled(false)
      }
    })()
    return () => {
      mounted = false
    }
  }, [])

  return enabled
}

